import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取协助平台列表
export const assistPlatform = data => {
  return axios.request({
    url: `/finance/feedback${data.id ? "/" + data.id : ""}`,
    data,
    method: data.method ? data.method : "get"
  });
};

// 添加协助平台
export const addAssistPlatform = data => {
  return axios.request({
    url: `/finance/feedback`,
    data,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};

// 更新协助平台
export const updateAssistPlatform = obj => {
  return axios.request({
    url: `/finance/feedback/update/${obj.id}`,
    data: obj.data,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    }
  });
};

//协助平台完结
export const assistPlatformFinish = id => {
  return axios.request({
    url: `/finance/feedback/finish/${id}`,
    method: "post"
  });
};

// 删除协助平台附件
export const deleteAssistPlatformFile = id => {
  return axios.request({
    url: `/finance/feedback/delImg/${id}`,
    method: "post"
  });
};
